/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompanyAssetGroupModel } from "data/models/CompanyModel";


export interface AssetGroupsState {

   assetGroupsLoading: boolean;
   assetGroups: CompanyAssetGroupModel[];

   assetGroupLoading: boolean;
   loadedAssetGroup?: CompanyAssetGroupModel;

   selectedAssetGroup?: CompanyAssetGroupModel;

   createAssetGroupInProgress: boolean;
   updateAssetGroupInProgress: boolean;
   deleteAssetGroupInProgess: boolean;

}


const initialState: AssetGroupsState = {

   assetGroupsLoading: false,
   assetGroups: [],

   assetGroupLoading: false,

   createAssetGroupInProgress: false,
   updateAssetGroupInProgress: false,
   deleteAssetGroupInProgess: false

}


export const slice = createSlice({

   name: "assetGroups",

   initialState,

   reducers: {

      // clear / load all

      clearAssetGroups: (state) => {
         state.assetGroups = [];
         state.selectedAssetGroup = undefined;
      },

      loadAssetGroups: (state, action: PayloadAction<{ companyId: string}>) => {
         state.assetGroupsLoading = true;
      },

      assetGroupsLoaded: (state, action: PayloadAction<{ assetGroups: CompanyAssetGroupModel[] }>) => {
         state.assetGroupsLoading = false;
         state.assetGroups = action.payload.assetGroups;
      },

      assetGroupsLoadingError: (state, action: PayloadAction<{ err: any}>) => {
         state.assetGroupsLoading = false;
         console.error(action.payload.err);
      },

      // load single

      loadAssetGroup: (state, action: PayloadAction<{companyId: string, assetGroupId: string}>) => {
         state.assetGroupLoading = false;
      },

      assetGroupLoaded: (state, action: PayloadAction<{ assetGroup: CompanyAssetGroupModel }>) => {
         state.assetGroupLoading = false;
         state.loadedAssetGroup = action.payload.assetGroup;
      },

      assetGroupLoadingError: (state, action: PayloadAction<{ err: any }>) => {
         state.assetGroupLoading = false;
         console.error(action.payload.err);
      },

      // Select active

      selectAssetGroupById: (state, action: PayloadAction<{ id: string }>) => {
         state.selectedAssetGroup = state.assetGroups.find(a => a.id === action.payload.id);
      },

      selectAssetGroupByName: (state, action: PayloadAction<{ name: string }>) => {
         state.selectedAssetGroup = state.assetGroups.find(a => a.name === action.payload.name);
      },

      // Create

      createAssetGroup: (state, action: PayloadAction<{ companyId: string, name: string, description: string }>) => {
         state.createAssetGroupInProgress = true;
      },

      assetGroupCreated: (state, action: PayloadAction<{ assetGroup: CompanyAssetGroupModel }>) => {
         state.assetGroups.push(action.payload.assetGroup);
         state.selectedAssetGroup = action.payload.assetGroup;
         state.createAssetGroupInProgress = false;
      },

      assetGroupCreationFailed: (state, action: PayloadAction<{ err: any }>) => {
         state.createAssetGroupInProgress = false;
         console.log(action.payload.err);
      },

      // Update

      updateAssetGroup: (state, action: PayloadAction<{ assetGroup: CompanyAssetGroupModel }>) => {
         state.updateAssetGroupInProgress = true;
      },

      assetGroupUpdated: (state, action: PayloadAction<{ assetGroup: CompanyAssetGroupModel }>) => {
         const i = state.assetGroups.findIndex(a => a.id === action.payload.assetGroup.id);
         if (i >= 0) state.assetGroups[i] = action.payload.assetGroup;
         if (state.selectedAssetGroup && state.selectedAssetGroup.id === action.payload.assetGroup.id) state.selectedAssetGroup = action.payload.assetGroup;
         state.updateAssetGroupInProgress = false;
      },

      assetGroupUpdateFailed: (state, action: PayloadAction<{ err: any }>) => {
         state.updateAssetGroupInProgress = false;
         console.log(action.payload.err);
      },

      // Delete

      deleteAssetGroupById: (state, action: PayloadAction<{ id: string }>) => {
         state.deleteAssetGroupInProgess = true;
      },

      assetGroupDeleted: (state, action: PayloadAction<{ id: string }>) => {
         state.assetGroups.splice(
            state.assetGroups.findIndex(a => a.id === action.payload.id), 1
         )
         if (state.selectedAssetGroup && state.selectedAssetGroup.id === action.payload.id) state.selectedAssetGroup = undefined;
         state.deleteAssetGroupInProgess = false;
      },

      assetGroupDeletionFailed: (state, action: PayloadAction<{ err: any }>) => {
         state.deleteAssetGroupInProgess = true;
         console.error(action.payload);
      }

   }

});


export const actions = slice.actions;

export default slice.reducer;



